import React from "react";
import { ScreenFrame } from "components/onboarding/ScreenFrame";
import { ErrorBoundary } from "react-error-boundary";

const ErrorBoundaryScreen = ({ children }) => {
  const logError = (error: Error) => {
    console.log("Logging: ", error);
  };

  return (
    <ErrorBoundary
      onError={logError}
      fallback={
        <ScreenFrame
          body={["Por favor, tente recarregar a página ou volte mais tarde."]}
          buttonText="Recarregar página"
          title={`Ops! Algo deu errado.`}
          variant="error"
          onClick={() => window.location.reload()}
        />
      }
    >
      {children}
    </ErrorBoundary>
  );
};

export default ErrorBoundaryScreen;
